import { Form } from 'react-bootstrap';
import { observer } from 'mobx-react-lite';

import { EditRoleReference } from 'edit/reference/EditRoleReference';
import { EditUserReference } from 'edit/reference/EditUserReference';

import type { EditableNodeDefinition } from '../../edit/EditableNodeDefinition';

/**
 * Owner user / role pickers. Both are stored in the node's `config` (the backend reads `config.owner_user` /
 * `config.owner_role` when raising an operator message on failure) but surfaced for every node type; the model exposes them
 * as first-class `ownerUser` / `ownerRole` fields, so this is a pure observer over those. Each reference control loads its
 * own users / roles LOV.
 */
const Ownership = observer(({ entity }: { readonly entity: EditableNodeDefinition }) => (
  <div className="mb-4">
    <h5>Ownership</h5>

    <Form.Group className="mb-2">
      <EditUserReference value={entity.ownerUser} onChange={(v) => (entity.ownerUser = v)} />
    </Form.Group>

    <Form.Group className="mb-2">
      <EditRoleReference value={entity.ownerRole} onChange={(v) => (entity.ownerRole = v)} />
    </Form.Group>
  </div>
));

export default Ownership;
